export const VALUES = {
    TEXT_LENGTH: 1000,
};
